import { ThunkDispatch } from "core-integration/src/store";
import { leaveLeague } from "core-integration/src/store/leagues/thunks";
import { ConfirmDialog } from "plos/src/components/ConfirmDialog";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { LeaveLeagueDialogProps } from "./types";

const LeaveLeagueDialog = ({
  league,
  isOpen,
  handleClose,
}: LeaveLeagueDialogProps) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const { t } = useTranslation("leaguesAndCups");

  const handleLeave = () => {
    dispatch(leaveLeague(league.id));
    handleClose();
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onCancel={handleClose}
      onConfirm={handleLeave}
      label={t(
        "leagueType.leaveLeagueDialog.dialogLabel",
        "Are you sure you want to leave {{leagueName}}?",
        {
          leagueName: league.name,
        },
      )}
      header={t(
        "leagueType.leaveLeagueDialog.message",
        "Are you sure you want to leave {{leagueName}}?",
        {
          leagueName: league.name,
        },
      )}
      confirmButtonText={t(
        "leagueType.leaveLeagueDialog.confirmLeave",
        "Yes, I want to leave this league",
      )}
      cancelButtonText={t(
        "leagueType.leaveLeagueDialog.cancelLeave",
        "No, I don't want to leave",
      )}
    />
  );
};

export default LeaveLeagueDialog;
